module.exports = __webpack_public_path__ + "img/services-dttcs-03.e071c8b4.svg";